import { render } from "./App.vue?vue&type=template&id=72c0d269"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import exportComponent from "E:\\vue project\\laravelvuetest\\vue-example-app-test\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__